import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import TrashButton from "@/components-UI/buttons/TrashButton.vue";
import SvgTrash from "@/assets/icons/trash-white.svg";
import SvgReset from "@/assets/icons/reset-white-small.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteRowTooltip',
  emits: ['delete'],
  setup(__props, { emit }) {



const tooltipEl = ref<InstanceType<typeof BaseTooltip> | null>(null);
const isActiveTooltip = computed(() => tooltipEl.value?.isShowTooltip);

const confirmDelete = () => {
    emit('delete');
    tooltipEl.value?.closeTooltip();
};

const cancelDelete = () => {
    tooltipEl.value?.closeTooltip();
};

return { __sfc: true,emit, tooltipEl, isActiveTooltip, confirmDelete, cancelDelete, BaseTooltip, TrashButton, SvgTrash, SvgReset }
}

})